<template>
  <div class="survey-step-two">
    <p>This feature will be available soon.</p>
    <div class="notify-button__wrapper">
      <aha-antd-button
        variant="secondary"
        name="spellchecker-fake-door-notify-button"
        v-aha-click="onNotifyButtonClicked"
      >
        Notify me when it’s available
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
import utils from '@/util'

export default {
  methods: {
    onNotifyButtonClicked() {
      utils.showToastSuccess('Thank you! You’ll be notified when it’s ready.')
      this.$emit('onNotifyButtonClicked')
    },
  },
}
</script>

<style lang="scss" scoped>
.survey-step-two {
  @apply pt-4;
}
.notify-button__wrapper {
  @apply w-full text-right pt-4;
}
</style>
